const shortenedPath = (pathname = '') =>
  pathname
    .replace(/^\/stores\/\d+\/?/, '/')
    .replace(/\/\d+\//, '/*/')
    .replace(/\/\d+$/, '/*');

const scrubbedParams = (search = '') => {
  if (!search) {
    return '';
  }

  const asObj = Object.fromEntries(new URLSearchParams(search));
  Object.keys(asObj).forEach((i) => (asObj[i] = ''));

  return `?${new URLSearchParams(asObj).toString()}`;
};

export const trackingPath = (pathname: string, search: string) =>
  `${shortenedPath(pathname)}${scrubbedParams(search)}`;
